<template>
  <b-col lg="4" md="12" class="">
    <b-card :title="`${brand.name}`"
            :img-src="`${brand.image}`"
            img-alt="Image"
            img-top
            title-tag="h5"
            img-width="250"
            img-height="200"
            tag="article"
            style="max-width: 20rem;"
            class="mb-2 ml-md-auto mr-md-auto ml-3 mt-2 text-center">

      <b-card-body>
        <b-row>
          <b-col>

            <b-button pill v-if="restoreWith == null" :to="{name:'EditBrand',params:{slug:brand.slug}}" variant="primary"
                      size="sm" class="mr-1">
              <i class="fas fa-heart"></i>
              ویرایش
            </b-button>

            <b-button pill v-else @click="restore" variant="primary" size="sm" class="mr-1">
              <i class="fas fa-heart"></i>
              بازیابی
            </b-button>


            <b-button pill @click="deleteFunction" variant="danger" size="sm" class="mr-1">
              حذف
              <i class="fas fa-comment"></i>
            </b-button>

          </b-col>
        </b-row>
      </b-card-body>

    </b-card>
  </b-col>
</template>

<script>
export default {
  name: "item",
  props: ['brand', 'removeWith', 'restoreWith'],
  methods: {
    deleteFunction() {
      if (confirm('آیا از حذف این برند اطمینان دارید؟')) {
        this.removeWith(this.brand);
      }
    },
    restore() {
      if (confirm('آیا از بازیابی این برند اطمینان دارید؟')) {
        this.restoreWith(this.brand);
      }
    }
  }
}
</script>

<style scoped>

</style>